<template>
  <div>
    <v-list
        class="py-0"
        :dense="$vuetify.breakpoint.mobile"
    >
      <v-subheader>О закупке</v-subheader>

      <div v-if="loading">
        <div
            v-for="i in 2"
            :key="i"
        >
          <v-skeleton-loader type="list-item-avatar-three-line">
          </v-skeleton-loader>
          <v-divider inset></v-divider>
        </div>
      </div>
      <div v-else-if="buyout && buyoutItem">
        <v-list-item
            three-line
            @click="toBalance()"
        >
          <v-list-item-avatar>
            <v-img
                :src="buyout.preview"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{buyout.title}}</v-list-item-title>
            <v-list-item-subtitle v-if="showBalance">
              <BalancePreview
                  :ccy="ccy"
                  :data="balanceInfo"
                  :loading="balanceLoad"
              ></BalancePreview>
            </v-list-item-subtitle>
            <v-list-item-subtitle>организатор: {{buyout.admin.fullName}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>

        <v-list-item
            :three-line="!!buyout.dates && buyout.minimalSumShowLK"
            @click="openStatusInfo"
        >
          <v-list-item-avatar>
            <v-icon :style="{color: 'white', backgroundColor: buyoutStatus.color}">
              {{buyoutStatus.icon}}
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title :style="{color: buyoutStatus.color}">{{buyoutStatus.title}}</v-list-item-title>
            <v-list-item-subtitle>
              <BuyoutDate
                  :dates="buyout.dates"
                  :status="buyout.status"
              ></BuyoutDate>
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="buyout.minimalSumShowLK">
              <BuyoutMinimalSum
                  :actual="buyout.minimalSumActual"
                  :ccy="ccy"
                  :value="buyout.minimalSum"
                  :text="true"
              ></BuyoutMinimalSum>
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn
                color="accent"
                icon
            >
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider
            v-if="buyoutItem.refundTransaction"
            inset
        ></v-divider>

        <v-list-item
            v-if="buyoutItem.refundTransaction"
            two-line
        >
          <v-list-item-avatar>
            <v-icon class="primary white--text">mdi-receipt</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="primary--text">
              Возврат за непришедшие: <b>{{buyoutItem.refundTransaction.amount | number}} {{ccy}}</b>
            </v-list-item-title>
            <v-list-item-subtitle>{{buyoutItem.refundTransaction.note}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>
    <DialogShowBuyoutStatusHistory
        :buyout="buyout"
        :event="statusDialogEvent"
        @close="statusDialogEvent = null"
        :sourceStatuses="sourceStatuses"
    ></DialogShowBuyoutStatusHistory>
  </div>
</template>

<script>
import BalancePreview from '@/components/BalancePreview'
import BuyoutDate from '@/components/BuyoutDate'
import BuyoutMinimalSum from '@/components/BuyoutMinimalSum'
import DialogShowBuyoutStatusHistory from '@/components/DialogShowBuyoutStatusHistory'
import {appStates, ccy} from '@/constants'
import Statuses from '@/services/statuses'

export default {
  name: 'BuyoutItemInfoAbout',
  components: {DialogShowBuyoutStatusHistory, BalancePreview, BuyoutMinimalSum, BuyoutDate},
  computed: {
    buyoutStatus: function () {
      return this.buyout ? Statuses.getStatuses()[this.buyout.status] : ''
    },
    showBalance: function () {
      return ccy.RUB.sign === this.ccy
    }
  },
  data () {
    return {
      balanceInfo: {},
      balanceLoad: true,
      statusDialogEvent: null,
      statuses: Statuses.getStatuses()
    }
  },
  methods: {
    openStatusInfo (event) {
      this.statusDialogEvent = event
    },
    toBalance(balanceInfo = this.balanceInfo) {
      this.$router.push({name: appStates.buyoutBalance.name, params: {balanceInfo}})
    }
  },
  props: {
    buyout: {
      type: Object
    },
    buyoutItem: {
      type: Object
    },
    ccy: {
      type: String
    },
    loading: {
      required: true,
      type: Boolean
    },
    sourceStatuses: {
      type: Object
    }
  },
  watch: {
    buyout: {
      handler: function (val) {
        if (!val) {
          return
        }
        this.$client.get(this.$API.BALANCES.INFO, {params: {buyoutId: val.id}})
        .then(data => this.balanceInfo = data)
        .finally(() => this.balanceLoad = false)
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>